import localeData from './locale-codes-data';

// The default locale used by nextjs.
// Used to determine whether localization redirects are needed or to stop additional pages being built if they don't support localization yet.
export const DEFAULT_LANGUAGE = localeData.defaultLocale;
export const languages = localeData.languages;
export const languageList = Object.values(languages);
export const supportedLocaleCodes = languageList.map((language) => language.id);
export type SupportedLocaleCode = (typeof supportedLocaleCodes)[number];
export const languagePreferenceOptions = (
  languageList.filter((language) => 'preferenceCode' in language) as {
    id: string;
    preferenceCode: string;
    label: string;
  }[]
).map((language) => ({
  label: language.label,
  value: language.preferenceCode,
}));
